// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"0049138e","796":"ca10f054"}[chunkId] + ".chunk.js";
};